// extracted by mini-css-extract-plugin
module.exports = {"root":"app-circle-progress_root__29RGi","bottom":"app-circle-progress_bottom__Ojvlp","top":"app-circle-progress_top__3tDjU","topCircle":"app-circle-progress_topCircle__1Ph4X"};